import { Result, backendApi } from "./backendApi";
import { LocaleModel } from "./drawingApi";

class GetTranslatedAttributeWindowsRequest {
  constructor(
    public templates: AttributeWindowTextModel[],
    public locales: LocaleModel[],
  ) {}
}

class GetTranslatedAttributeWindowsResponse {
  constructor(public translations: LocalizedAttributeWindowTextModel[]) {}
}

export class AttributeWindowTextModel {
  constructor(
    public title: string,
    public text: string,
  ) {}
}

export class LocalizedAttributeWindowTextModel {
  constructor(
    public title: string,
    public text: string,
    public locale: LocaleModel,
  ) {}
}

class GetTemplatedAttributeWindowsRequest {
  constructor(
    public vehicleFileNumber: string | undefined,
    public attributeWindows: AttributeWindowTextModel[],
  ) {}
}

export class GetTemplatedAttributeWindowsResponse {
  constructor(
    public templates: AttributeWindowTextModel[],
    public unmatchedStrings: string[],
    public knownUnmatchedStrings: string[],
  ) {}
}

export class GetMissingTranslationsRequest {
  constructor(public templatedWindows: AttributeWindowTextModel[]) {}
}

export class GetMissingTranslationsResponse {
  constructor(public missingTranslations: string[]) {}
}

export const glossaryApi = {
  async getTranslatedAttributeWindows(
    templates: AttributeWindowTextModel[],
    locales: LocaleModel[],
  ): Promise<Result<LocalizedAttributeWindowTextModel[]>> {
    const response =
      await backendApi.sendAndGetResponseAsync<GetTranslatedAttributeWindowsResponse>(
        "GetTranslatedAttributeWindows",
        new GetTranslatedAttributeWindowsRequest(templates, locales),
      );

    if (response.ok) {
      return { ok: true, value: response.value.translations };
    }

    return response;
  },

  async getTemplatedAttributeWindows(
    vehicleFileNumber: string | undefined,
    attributeWindows: AttributeWindowTextModel[],
  ): Promise<Result<GetTemplatedAttributeWindowsResponse>> {
    return await backendApi.sendAndGetResponseAsync<GetTemplatedAttributeWindowsResponse>(
      "GetTemplatedAttributeWindows",
      new GetTemplatedAttributeWindowsRequest(
        vehicleFileNumber,
        attributeWindows,
      ),
    );
  },

  async getMissingTranslations(
    templatedWindows: AttributeWindowTextModel[],
  ): Promise<Result<GetMissingTranslationsResponse>> {
    return await backendApi.sendAndGetResponseAsync<GetMissingTranslationsResponse>(
      "GetMissingTranslations",
      new GetMissingTranslationsRequest(templatedWindows),
    );
  },
};
